import { Formik } from 'formik';
import { ModalWithStyles } from './ModalWithStyles';

export function DeleteSheduledReportModal({
  deleteId,
  handleClose,
  show,
  deleteRow,
  handleDeletion,
}) {
  return (
    <Formik
      onSubmit={async (values, actions) => {
        handleDeletion(values.deleteId);
        actions.resetForm({});
        handleClose();
      }}
      enableReinitialize={true}
      initialValues={{
        deleteId: deleteId ?? '',
      }}
    >
      {(formik) => (
        <>
          <form
            className="form form-label-right"
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <ModalWithStyles
              onSubmit={formik.handleSubmit}
              title="Delete Scheduled Report"
              aria-labelledby="example-modal-sizes-title-md"
              show={show}
              onHide={handleClose}
              isSubmitting={formik.isSubmitting}
              isLoading={formik.isSubmitting}
              deleteDialog={true}
              dataPup="delete-dialog-scheduled-report"
              size="xs"
            >
              <p>
                Once <em>{deleteRow?.name}</em> is removed the scheduled reports
                will no longer send and this action cannot be reversed.
              </p>

              <p>Are you sure you want to delete this Scheduled Report?</p>
            </ModalWithStyles>
          </form>
        </>
      )}
    </Formik>
  );
}
